var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAllChannel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "allChannel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-Room-NAV",
    transform: "translate(-90.000000, -640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-room-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Specializations/White",
    transform: "translate(0.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1957895,8.17139955 L18.3789474,8.17139955 L21.6757895,3.32368925 C22.1305263,2.66440065 21.9410526,1.77242196 21.3347368,1.30704177 C20.6905263,0.841661581 19.7810526,0.996788311 19.3642105,1.65607691 L15.6126316,7.16307581 L11.8610526,1.61729523 C11.4063158,0.958006628 10.5347368,0.802879899 9.89052632,1.26826009 C9.24631579,1.73364028 9.09473684,2.62561897 9.54947368,3.28490757 L12.8463158,8.17139955 L2.80421053,8.17139955 C1.25052632,8.17139955 0,9.45119507 0,11.041244 L0,31.1301555 C0,32.7202045 1.25052632,34 2.80421053,34 L33.1957895,34 C34.7494737,34 36,32.7202045 36,31.1301555 L36,11.0024624 C36,9.45119507 34.7494737,8.17139955 33.1957895,8.17139955 Z M27,30 L3,30 L3,12 L27,12 L27,30 Z M31.5,22 C30.675,22 30,21.325 30,20.5 C30,19.675 30.675,19 31.5,19 C32.325,19 33,19.675 33,20.5 C32.9625,21.2875 32.325,22 31.5,22 Z M31.5,30 C30.125,30 29,28.875 29,27.5 C29,26.125 30.125,25 31.5,25 C32.875,25 34,26.125 34,27.5 C33.9375,28.875 32.875,30 31.5,30 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAllChannel);
export default __webpack_public_path__ + "static/media/ic_all_channel.54a0c18e.svg";
export { ForwardRef as ReactComponent };